import _extends from 'babel-runtime/helpers/extends';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

/* eslint-disable max-lines */
import _ from 'lodash';
import { parseTime } from '@/filters/index';
import Pagination from '@/components/Pagination/index.vue';
import TableList from '@/components/TableList/index.vue';
import searchMixin from '@/mixin/search';
import SearchBar from '@/components/SearchV3/index.vue';
import { fetchSubscriberList, referersList } from '@/api/website/blog';
import { v2Host } from '@/config/host';
import { downloadWithNewWindow } from '@/common/download.js';
import qs from 'qs';

export default {
  components: {
    Pagination: Pagination,
    TableList: TableList,
    SearchBar: SearchBar
  },
  mixins: [searchMixin],
  data: function data() {
    return {
      query: {
        page: 1,
        page_size: 15,
        keyword: '',
        created_time: [],
        order: '-created_time',
        type: '',
        referer: ''
      },
      pagination: {
        total: 0
      },
      listLoading: false,
      list: [],
      refererOptions: []
    };
  },

  watch: {
    $route: function $route(to, from) {
      this.getReferersList();
      this.getList(this.query);
    }
  },
  computed: {
    formItemList: function formItemList() {
      var _this = this;

      return [{
        type: 'input',
        prop: 'keyword',
        subtype: 'text',
        params: {
          clearable: true,
          placeholder: '请输入邮箱'
        }
      }, {
        type: 'cascader',
        prop: 'type_referer',
        params: {
          clearable: true,
          placeholder: '请选择来源',
          props: { checkStrictly: true },
          options: this.refererOptions,
          handleChange: function handleChange(val) {
            _this.query.type = val[0];
            _this.query.referer = val[1];
            // this.getList(this.query)
          }
        }
      }, {
        type: 'date-picker',
        subtype: 'datetimerange',
        prop: 'created_time',
        class: 'date-picker',
        params: {
          clearable: true,
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd',
          startPlaceholder: '创建开始时间',
          endPlaceholder: '创建结束时间',
          pickerOptions: {
            disabledDate: function disabledDate(time) {
              return time.getTime() > Date.now();
            }
          }
        }
      }];
    },
    tableColumnConfig: function tableColumnConfig() {
      return [{
        label: '姓名',
        prop: 'full_name'
      }, {
        label: '国家或地区',
        prop: 'region'
      }, {
        label: '公司',
        prop: 'company'
      }, {
        label: '公司类型',
        prop: 'company_type'
      }, {
        label: '职位',
        prop: 'job_title'
      }, {
        label: '邮箱',
        prop: 'email'
      }, {
        label: '电话',
        prop: 'phone'
      }, {
        label: '联系方式类型',
        prop: 'contact_type'
      }, {
        label: '联系方式',
        prop: 'contact_account'
      }, {
        label: '感兴趣内容',
        prop: 'interested_in'
      }, {
        label: '了解mindwork途径',
        prop: 'hear_about'
      }, {
        label: '留言内容',
        prop: 'message'
      }, {
        label: '是否订阅',
        prop: 'is_subscribe',
        params: {
          innerText: function innerText(_ref) {
            var row = _ref.row;

            return Number(row.is_subscribe) === 1 ? '是' : '否';
          }
        }
      }, {
        label: '来源',
        prop: 'referer',
        params: {
          innerText: function innerText(_ref2) {
            var row = _ref2.row;

            if (row.referer) {
              // const regex = new RegExp(`${row.type}:${row.referer}`, 'i')
              // const temp = self.refererOptions.find((s) =>
              //   regex.test(s.value),
              // )
              // return temp ? temp.label : '-'
              return row.referer;
            }

            return '-';
          }
        }
      }, {
        label: '推广产品类型',
        prop: 'product_type'
      }, {
        label: '主要推广产品商店链接',
        prop: 'app_url'
      }, {
        label: '创意团队规模',
        prop: 'team_size'
      }, {
        label: '是否已与Mintegral合作',
        prop: 'is_mtg',
        params: {
          innerText: function innerText(_ref3) {
            var row = _ref3.row;

            return row.is_mtg ? '是' : '否';
          }
        }
      }, {
        label: 'Mintegral username',
        prop: 'm_username'
      }, {
        label: '感兴趣的玩法',
        prop: 'interesting_gameplay'
      }, {
        label: '感兴趣的视频功能',
        prop: 'interesting_videos'
      }, {
        label: '留资时间',
        prop: 'created_time',
        params: {
          innerText: function innerText(_ref4) {
            var row = _ref4.row;

            return parseTime(row.created_time, '{y}-{m}-{d} {h}:{i}:{s}');
          }
        }
      }, {
        label: '期望开通日期',
        prop: 'effective_time',
        params: {
          innerText: function innerText(_ref5) {
            var row = _ref5.row;

            return parseTime(row.effective_time, '{y}-{m}-{d} {h}:{i}:{s}');
          }
        }
      }, {
        label: '开通天数',
        prop: 'effective_days'
      }, {
        label: '推荐人',
        prop: 'recommender'
      }, {
        label: 'LPURL',
        prop: 'lp_url'
      }, {
        label: 'CampaignID',
        prop: 'campaign_id'
      }, {
        label: 'Adgroupid',
        prop: 'ad_group_id'
      }, {
        label: 'Keyword',
        prop: 'keyword'
      }];
    }
  },
  mounted: function mounted() {
    this.getReferersList();
    this.getList(this.query);
  },

  methods: {
    handleExport: function handleExport() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                try {
                  downloadWithNewWindow(v2Host + '/website/subscriber/export?' + qs.stringify(_this2.query));
                } catch (error) {
                  console.log(error);
                }

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getReferersList: function getReferersList() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var labelMap, res, data, key, item, v;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.refererOptions = [];

                labelMap = {
                  contact_us: 'MWS官网',
                  pt_register: 'PT在线注册',
                  pt_trial: 'PT试用申请'
                };
                _context2.prev = 2;
                _context2.next = 5;
                return referersList();

              case 5:
                res = _context2.sent;
                data = _.get(res, 'data.data') || {};


                if (_JSON$stringify(data) !== '{}') {
                  for (key in data) {
                    item = {
                      value: key,
                      label: labelMap[key] || key,
                      children: []
                    };

                    for (v in data[key]) {
                      item.children.push({
                        value: v,
                        label: v
                      });
                    }

                    _this3.refererOptions.push(item);
                  }
                }
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](2);

                console.log(_context2.t0);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[2, 10]]);
      }))();
    },
    getList: function getList(query) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var postData, res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                postData = _extends({}, query.created_time.length ? {
                  start_date: query.created_time[0],
                  end_date: query.created_time[1]
                } : {}, _.omit(query, ['created_time']));
                // 更新时间

                _context3.prev = 1;

                _this4.listLoading = true;
                _context3.next = 5;
                return fetchSubscriberList(postData);

              case 5:
                res = _context3.sent;

                _this4.listLoading = false;
                _this4.list = _.get(res, 'data.data.list', []).map(function (item) {
                  return _extends({}, item, {
                    is_mtg: Boolean(item.m_username)
                  });
                });
                _this4.pagination.total = _.get(res, 'data.data.total', 0);
                _context3.next = 14;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](1);

                _this4.listLoading = false;

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[1, 11]]);
      }))();
    }
  }
};